"use client";

import { Icons } from "@/components/icons";
import Section from "@/components/section";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { useTranslations } from "@/lib/hooks/use-translations";

export default function CtaSection({ locale = "en" }: { locale?: "de" | "en" | "zh-CN" } = {}) {
  const { t, locale: currentLocale } = useTranslations();

  const getContactUrl = () => {
    const localeToUse = currentLocale || locale;
    if (localeToUse === "de") return "/de/kontakt";
    if (localeToUse === "zh-CN") return "/zh-CN/contact";
    return "/contact";
  };

  return (
    <Section
      id="cta"
      title={t('pages.home.cta.title')}
      subtitle={t('pages.home.cta.description')}
      className="bg-primary/10 rounded-xl py-16"
    >
      <div className="flex flex-col w-full sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 pt-4">
        <Link
          href={getContactUrl()}
          className={cn(
            buttonVariants({ variant: "default" }),
            "w-full sm:w-auto text-background flex gap-2"
          )}
        >
          <Icons.logoIcon className="h-6 w-6" />
          {t('pages.home.hero.cta.getStarted')}
        </Link>
      </div>
    </Section>
  );
}
